import { ReactNode, createContext } from 'react';
import { API } from '@shared/types/api';
import { useChannelUsers } from '@shared/util/hooks';

interface WorkflowTemplateData {
  users: API.ShortUserFragment[];
}

interface Props {
  channelId?: number;
  children: ReactNode;
}

export const WorkflowTemplateDataContext = createContext<WorkflowTemplateData>({
  users: [],
});

export function WorkflowTemplateDataProvider({ channelId, children }: Props) {
  const { users } = useChannelUsers({ channelId });
  return (
    <WorkflowTemplateDataContext.Provider value={{ users }}>
      {children}
    </WorkflowTemplateDataContext.Provider>
  );
}
